import React, { useState } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { ChangesSetsList } from './ChangesSetsList';
import { ExpandableHeader } from './ExpandableHeader';

interface Props {
  requestId?: string;
}

export const ContributionActivityLogs: React.FC<Props> = ({ requestId }) => {
  const [isExpanded, setExpanded] = useState(false);

  return (
    <Box
      background="module"
      round="container1Round"
      pad="spacing16"
      margin={{ top: 'spacing16' }}
      data-testId={`ContributionActivityLogs_${requestId}`}
    >
      <Box
        pad="spacing16"
        background="canvas"
        round="container2Round"
        border={{ color: 'border2', size: 'medium' }}
      >
        <ExpandableHeader
          isExpanded={isExpanded}
          setExpanded={setExpanded}
          testId="ContributionActivityLogs"
        >
          <Box margin={{ left: 'spacing12' }}>
            <Inscription color="textBody" weight="bold">
              Activity Log
            </Inscription>
          </Box>
        </ExpandableHeader>
        {isExpanded ? (
          <Box
            pad="spacing24"
            round="container1Round"
            background="module"
            margin={{ top: 'spacing16' }}
          >
            <Box
              margin={{ bottom: 'spacing8' }}
              pad={{ horizontal: 'spacing12', vertical: '7px' }}
              background="legend"
              round="8px"
              width="100%"
              height="36px"
              direction="column"
              justify="center"
            >
              <Box
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  lineHeight: '18px',
                  color: 'textOnColor',
                }}
                direction="row"
                height="18px"
              >
                <Box flex>Date of change</Box>
                <Box flex>Author</Box>
                <Box flex>Source of change</Box>
                <Box flex>Changes</Box>
              </Box>
            </Box>
            <ChangesSetsList requestId={requestId} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
